import { motion } from "framer-motion";

const TermsPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="terms-page">
      <section className="py-16 md:py-24 bg-white">
        <div className="container-main">
          <motion.div {...fadeInUp} className="max-w-3xl mx-auto">
            <p className="caption mb-4">Legal</p>
            <h1 className="heading-1 mb-8">Terms of Service</h1>
            
            <div className="prose prose-zinc max-w-none">
              <p className="body-lg mb-8">
                Last updated: December 2025
              </p>

              <div className="space-y-8 body-text">
                <section>
                  <h2 className="heading-3 mb-4">1. Acceptance of Terms</h2>
                  <p>
                    By accessing or using The App Fam's applications and services, you agree to be bound by 
                    these Terms of Service. If you do not agree to these terms, please do not use our services.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">2. Use of Services</h2>
                  <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
                  <ul className="list-disc pl-6 mt-4 space-y-2">
                    <li>Use the services in any way that violates applicable laws</li>
                    <li>Attempt to interfere with or disrupt the services</li>
                    <li>Access or collect data through unauthorized means</li>
                    <li>Use the services to transmit harmful or malicious content</li>
                  </ul>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">3. User Accounts</h2>
                  <p>
                    When you create an account, you must provide accurate and complete information. 
                    You are responsible for maintaining the security of your account and password.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">4. Intellectual Property</h2>
                  <p>
                    Our services and their contents, features, and functionality are owned by The App Fam 
                    and are protected by copyright, trademark, and other intellectual property laws.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">5. User Content</h2>
                  <p>
                    You retain ownership of any content you create using our services. By using our services, 
                    you grant us a limited license to use, store, and process your content solely to provide 
                    the services to you.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">6. Limitation of Liability</h2>
                  <p>
                    The App Fam shall not be liable for any indirect, incidental, special, consequential, 
                    or punitive damages resulting from your use of or inability to use the services.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">7. Changes to Terms</h2>
                  <p>
                    We may modify these Terms at any time. We will notify you of any changes by posting 
                    the new Terms on our website. Your continued use of the services after such changes 
                    constitutes acceptance of the new Terms.
                  </p>
                </section>

                <section>
                  <h2 className="heading-3 mb-4">8. Contact Us</h2>
                  <p>
                    If you have any questions about these Terms, please contact us at{" "}
                    <a href="mailto:info@theappfam.com" className="text-zinc-900 underline underline-offset-4">
                      info@theappfam.com
                    </a>
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
